<template>
    <div id="createPostModal" class="js-modal-window u-modal-window" style="width: 680px;">
        <div class="card">
            <form @submit="submit_form" class="js-validate">
                <!-- Header -->
                <header class="card-header bg-light py-3 px-5">
                    <div class="d-flex justify-content-between align-items-center">
                        <h3 class="h6 mb-0">Faire un post!</h3>

                        <button type="button" ref="closeModalButton" class="close" aria-label="Close"
                                onclick="Custombox.modal.close();">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </header>
                <!-- End Header -->

                <div class="card-body p-5">
                    <div class="js-form-message form-group mb-3">
                        <input v-model="subject" type="text" class="form-control" name="subject" id="inputSubject" placeholder="Subject"
                               aria-label="Subject"
                               data-msg="Please enter the subject."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>

                    <div class="js-form-message form-group mb-3">
                        <!-- Select -->
                        <select v-model="category" class="js-select selectpicker dropdown-select" data-width="100%"
                                data-style="btn-soft-primary btn-sm">
                            <option value="BESOIN">Besoin</option>
                            <option value="ANNONCE">Annonce</option>
                        </select>
                        <!-- End Select -->
                    </div>

                    <div class="js-form-message form-group mb-3">
                        <textarea v-model="message" class="form-control" rows="7" id="descriptionTextarea"
                                  placeholder="Message" required
                                  data-msg="Please enter your message."
                                  data-error-class="u-has-error"
                                  data-success-class="u-has-success"/>
                    </div>

                    <div class="js-form-message form-group mb-3 input-group u-tagsinput">
                        <input ref="tagsInput" value="all,example" type="text" class="form-control" name="tags"
                               id="inputTags"
                               aria-label="Tags" data-role="tagsinput" style="display: none;"
                               placeholder="">
                    </div>

                    <div class="js-form-message form-group mb-3">
                        <span>Joindre images</span>
                        <input ref="images" type="file" multiple accept="image/*" class="form-control btn btn-sm btn-soft-primary">
                    </div>

                    <div class="js-form-message form-group mb-3">
                        <span>Joindre documents pdf</span>
                        <input ref="pdfs" type="file" multiple accept=".pdf" class="form-control btn btn-sm btn-soft-primary">
                    </div>

                    <div class="d-flex justify-content-center">
                        <LoadingButton v-if="requestIsLoading"/>
                        <button v-else type="submit" class="btn btn-sm btn-primary btn-wide transition-3d-hover mt-2">
                            Poster
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <script type="application/javascript" v-bind:src="tagsInputSrc"></script>
        <script type="application/javascript" v-bind:src="hsSelectPickerSrc"></script>
        <script type="application/javascript" v-bind:src="hsSelectPickerPluginInitSrc"></script>
    </div>
</template>

<script>
    import {CREATE_POST, GET_POSTS} from "../settings/graphql/index";
    import {JS_FILES} from "../settings/scripts";
    import {HOME_POST_PAGE_SIZE, UPLOAD_FILES_ENDPOINT} from "../settings";
    import LoadingButton from "./LoadingButton";

    export default {
        name: "CreatePostModal",
        components: {LoadingButton},
        data() {
            return {
                subject: "",
                category: "BESOIN",
                message: "",
                error: null,
                requestIsLoading: false,
                tagsInputSrc: JS_FILES.tagsInput,
                hsSelectPickerSrc: JS_FILES.hs.selectPicker,
                hsSelectPickerPluginInitSrc: JS_FILES.hs.pluginsInit.selectPicker
            };
        },
        methods: {
            submit_form: function (event) {
                event.preventDefault();
                this.$data.requestIsLoading = true;
                const {subject, category, message} = this.$data;
                const tags = this.$refs.tagsInput.value.split(",");

                let formData = new FormData();
                this.$refs.images.files.forEach(function (image, idx) {
                    formData.append(`image_${idx}`, image);
                });
                this.$refs.pdfs.files.forEach(function (pdf, idx) {
                    formData.append(`pdf_${idx}`, pdf);
                });

                let imagesUrls = [];
                let documentsUrls = [];

                const self = this;
                const closeModalButton = this.$refs.closeModalButton;

                this.axios.post(UPLOAD_FILES_ENDPOINT,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(response){
                    const filesUrls = response.data;
                    // console.log(`Images uploaded successfully: ${JSON.stringify(filesUrls)}`);

                    Object.keys(filesUrls).forEach( key => {
                        if (key.includes("image")){
                            imagesUrls.push(filesUrls[key]);
                        }
                        else{
                            documentsUrls.push(filesUrls[key]);
                        }
                    });

                    // console.log(`Images urls: ${JSON.stringify(imagesUrls)}`);
                    // console.log(`Documents urls: ${JSON.stringify(documentsUrls)}`);

                    self.$apollo.mutate({
                        mutation: CREATE_POST,
                        variables: {subject, category, message, tags, imagesUrls, documentsUrls},
                        update: (cache, result) => {
                            const created_post = result.data.createPost.post;

                            const get_posts_result = cache.readQuery({
                                query: GET_POSTS,
                                variables: {first: HOME_POST_PAGE_SIZE}
                            });

                            get_posts_result.posts.edges.unshift({
                                node: created_post,
                                __typename: "PostNodeEdge"
                            });

                            cache.writeQuery({
                                query: GET_POSTS,
                                data: get_posts_result
                            });
                        }
                    }).then(() => {
                        // console.log(`Post ${JSON.stringify(result)} successfully created`);
                        self.$data.requestIsLoading = false;
                        closeModalButton.click()
                    }).catch(() => {
                        // console.error(`Error ${error} on post creation`);
                        self.$data.requestIsLoading = false;
                    });

                })
                .catch(function(){
                    // console.log(`Error on images uploading...`);
                    self.$data.requestIsLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>